import { useEffect, useState, useMemo } from "react";
import {
  Container,
  Grid,
  LinearProgress,
  Typography,
  Button,
} from "@material-ui/core";
import { createStyles, withStyles, Theme } from "@material-ui/core/styles";
import Countdown from "react-countdown";
import { BigNumber } from "bignumber.js";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { GAME_TIME_CONFIG } from "../../const/config";
import { RootState, RootDispatch } from "../../model";
import GameResultModal from "../GameResultModal";
import { useRematch } from "../../utils/useRematch";
import useInterval from "../../utils/useInterval";

// import Map from "../../assets/game-map.png";
import Map from "../../assets/game-map-cheng.jpg";
import TVLogo from "../../assets/jackTV.png";
// import TVLogo from "../../assets/tv.png";
import "./index.less";

const totalRow = 27;
const totalColumn = 34;

const BorderLinearProgress = withStyles((theme: Theme) =>
  createStyles({
    root: {
      height: 10,
      margin: "30px 0",
      borderRadius: 5,
    },
    colorPrimary: {
      // backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
      backgroundColor: "#4c5054",
    },
    bar: {
      borderRadius: 5,
      backgroundImage: "linear-gradient( 135deg, #FFD26F 10%, #3677FF 100%)",
    },
  })
)(LinearProgress);

const mapState = (state: RootState) => ({
  ...state.main,
  loading: state.loading,
  modalState: { ...state.modal },
  ...state.game,
});

const mapDispatch = (dispatch: RootDispatch) => ({
  ...dispatch.main,
  ...dispatch.modal,
  ...dispatch.game,
});

const countDownRender = ({ days, hours, minutes, seconds, completed }: any) => {
  return (
    <div className="data-count-down">
      <div className="number" style={{ marginLeft: 0 }}>
        {hours < 10 ? `0${hours}` : hours}
      </div>
      :<div className="number">{minutes < 10 ? `0${minutes}` : minutes}</div>:
      <div className="number">{seconds < 10 ? `0${seconds}` : seconds}</div>
    </div>
  );
};

const getGridItemStyle = ({
  y,
  x,
  isWin,
  rect,
}: {
  y: number;
  x: number;
  isWin: boolean;
  rect: DOMRect | undefined;
}) => {
  if (rect === null) {
    return {
      display: "none",
    };
  } else {
    const ImgRect = rect;
    if (ImgRect) {
      const itemHeight = ImgRect.height / totalRow;
      const itemWidth = ImgRect.width / totalColumn;
      return {
        width: `${itemWidth}px`,
        height: `${itemHeight}px`,
        top: `${itemHeight * y}px`,
        left: `${itemWidth * x}px`,
        fontSize: `${itemWidth / 2}px`,
      };
    } else {
      return {
        display: "none",
      };
    }
  }
};

const MissChild = ({
  missCoords,
  rect,
}: {
  missCoords: { x: number; y: number }[];
  rect: DOMRect | undefined;
}) => {
  return (
    <div>
      {missCoords.map((coord, index) => (
        <div
          className="click-item miss"
          key={`miss-${index}`}
          style={getGridItemStyle({ ...coord, rect, isWin: false })}
        ></div>
      ))}
    </div>
  );
};

const WinChild = ({
  winCoords,
  rect,
}: {
  winCoords: { x: number; y: number }[];
  rect: DOMRect | undefined;
}) => {
  return (
    <div>
      {winCoords.map((coord, index) => (
        <div
          className="click-item win"
          key={`win-${index}`}
          style={getGridItemStyle({ ...coord, rect, isWin: true })}
        >
          🎉
        </div>
      ))}
    </div>
  );
};

const StrongText = ({ children }: { children: JSX.Element | string }) => {
  return <span style={{ color: "#ffc938", fontWeight: 600 }}>{children}</span>;
};

export default function Game() {
  const [
    {
      userInfo,
      nftNum,
      nftType,
      lastClickTime,
      winCoords,
      missCoords,
      loading,
      isDataInit,
      giftTimes,
      KungFuHeroContract,
      canRewardTimes,
      seconds,
      rankingRes,
    },
    {
      fetchGameData,
      clickMap,
      winnerGetReward,
      fetchGameContractData,
      setFields,
    },
  ] = useRematch(mapState, mapDispatch);

  const [percentValue, setPercentValue] = useState(0);

  useEffect(() => {
    if (userInfo.address) {
      fetchGameData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo]);

  const coldDownTime = useMemo(() => {
    let t = 45;
    let clickTime = dayjs(lastClickTime).unix() * 1000 || 0;
    // let config = GAME_TIME_CONFIG
    // if (nftType === 1) {
    //   switch (true) {
    //     case nftNum >= 1 && nftNum <= 2:
    //       t = GAME_TIME_CONFIG[0].coldDownTime;
    //       break;
    //     case nftNum >= 3 && nftNum <= 5:
    //       t = GAME_TIME_CONFIG[1].coldDownTime;
    //       break;
    //     case nftNum >= 6 && nftNum <= 10:
    //       t = GAME_TIME_CONFIG[2].coldDownTime;
    //       break;
    //     case nftNum >= 11 && nftNum <= 20:
    //       t = GAME_TIME_CONFIG[3].coldDownTime;
    //       break;
    //     case nftNum >= 21 && nftNum <= 30:
    //       t = GAME_TIME_CONFIG[4].coldDownTime;
    //       break;
    //     case nftNum > 30:
    //       t = GAME_TIME_CONFIG[5].coldDownTime;
    //       break;
    //     default:
    //       break;
    //   }
    // } else {
    //   t = GAME_TIME_CONFIG[6].coldDownTime;
    // }
    return t * 1000 + clickTime;
  }, [nftType, nftNum, lastClickTime]);

  useInterval(
    () => {
      let t = 45;
      // if (nftType === 1) {
      //   switch (true) {
      //     case nftNum >= 1 && nftNum <= 2:
      //       t = GAME_TIME_CONFIG[0].coldDownTime;
      //       break;
      //     case nftNum >= 3 && nftNum <= 5:
      //       t = GAME_TIME_CONFIG[1].coldDownTime;
      //       break;
      //     case nftNum >= 6 && nftNum <= 10:
      //       t = GAME_TIME_CONFIG[2].coldDownTime;
      //       break;
      //     case nftNum >= 11 && nftNum <= 20:
      //       t = GAME_TIME_CONFIG[3].coldDownTime;
      //       break;
      //     case nftNum >= 21 && nftNum <= 30:
      //       t = GAME_TIME_CONFIG[4].coldDownTime;
      //       break;
      //     case nftNum > 30:
      //       t = GAME_TIME_CONFIG[5].coldDownTime;
      //       break;
      //     default:
      //       break;
      //   }
      // } else {
      //   t = GAME_TIME_CONFIG[6].coldDownTime;
      // }
      const percent = new BigNumber(coldDownTime - Date.now())
        .div(t * 1000)
        .times(100)
        .toNumber();
      console.log("🚀 ~ file: index.tsx ~ line 250 ~ Game ~ pencent", percent);
      setPercentValue(seconds - 1 === 0 ? 0 : percent);
      setFields({
        seconds: seconds - 1,
      });
    },
    seconds <= 0 ? null : 1000
  );

  useInterval(
    () => {
      fetchGameData();
    },
    // mineableNum === 0 ? null : 8000
    8000
  );

  useEffect(() => {
    if (userInfo && KungFuHeroContract) {
      fetchGameContractData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo, KungFuHeroContract]);

  const [gameMainRefRect, setGameMainRefRect] = useState<DOMRect>();

  const onClickGameBox = async (event: React.MouseEvent<HTMLElement>) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setGameMainRefRect(rect);
    if (seconds > 0 || loading.effects.game.clickMap || nftType === 0) {
      return;
    }
    const clientX = event.clientX;
    const clientY = event.clientY;
    const y = Math.floor((clientY - rect.top) / (rect.height / totalRow));
    const x = Math.floor((clientX - rect.left) / (rect.width / totalColumn));
    let hasChoiced = false;
    for (let i = 0; i < winCoords.length; i++) {
      const coord = winCoords[i];
      if (coord.y === y && coord.x === x) {
        hasChoiced = true;
        return;
      }
    }
    for (let i = 0; i < missCoords.length; i++) {
      const coord = missCoords[i];
      if (coord.y === y && coord.x === x) {
        hasChoiced = true;
        return;
      }
    }
    if (hasChoiced) {
      return;
    }
    await clickMap({
      x: x,
      y: y,
    });
  };

  return (
    <div className="game">
      <GameResultModal />
      <Container maxWidth="lg">
        <Grid
          container
          spacing={4}
          wrap="wrap"
          alignContent="space-between"
          alignItems="center"
        >
          <Grid item xs={12} md={7} className="airdrop-desc">
            <Typography component="div" variant="h4" className="title">
              <span style={{ color: "#ffc938" }}>Treasure</span> hunt game
            </Typography>
            <Typography
              component="div"
              variant="h6"
              paragraph
              className="content"
            >
              <p>
                1. All participants need to hold at least 5 KFH or 1 Rivermen.
              </p>
              <p>2. Every treasure you find counts as 1 point.</p>
              <p>3. The Hunt will last 45 min each day.</p>
              <p>4. Cool down time for everyone is 45s.</p>
              Weekly Prizes:
              <p>1 Rivermen for Weekly Top 3 Hunters.</p>
              <p>1 KFH for Weekly Top 7 Hunters.</p>
              <p>
                1 Rivermen raffle for all Game participants (have at least 1
                point for the week).
              </p>
              <p>
                1 KFH for Weekly Top 3 Active Users in the KungFu Hero discord.
              </p>
            </Typography>
            {/* <Typography
              component="div"
              variant="h6"
              paragraph
              className="content rules"
            >
              There is a time limit on clicking:
              <p>
                1. If you own <StrongText>1 - 2 KungFu Hero</StrongText>, you
                can sweep every <StrongText>3 minutes</StrongText>;
              </p>
              <p>
                2. If you own <StrongText>3 - 5 KungFu Heroes</StrongText>, you
                can sweep every <StrongText>2 minutes</StrongText>;
              </p>
              <p>
                3. If you own <StrongText>6 - 10 KungFu Heroes</StrongText>, you
                can sweep every <StrongText>1 minutes</StrongText>;
              </p>
              <p>
                4. If you own <StrongText>11 - 20 KungFu Heroes</StrongText>,
                you can sweep every <StrongText>50 s</StrongText>;
              </p>
              <p>
                5. If you own <StrongText>21 - 30 KungFu Heroes</StrongText>,
                you can sweep every <StrongText>40 s</StrongText>;
              </p>
              <p>
                6. If you own over <StrongText>30 KungFu Heroes</StrongText>,
                you can sweep every <StrongText>30 s</StrongText>;
              </p>
              <p>
                7. If you are holder of other NFTs, you can sweep every{" "}
                <StrongText>5 minutes</StrongText>;<br />
                (includes: BAYC Apes, CryptoPunks, Meebits, Cool Cats, The Alien
                boy, Bulls on the Block, Bonsai by ZENFT)
              </p>
            </Typography> */}
          </Grid>
          <Grid item xs={12} md={5} className="tv-img">
            <img src={TVLogo} width="100%" alt="" />
          </Grid>
        </Grid>
        <Grid
          container
          spacing={4}
          className="game-container"
          justify="center"
          alignItems="center"
        >
          <Grid item xs={12} md={12} className="game-box">
            {/* <div className="data-box treasure-data">
              <Grid container justify="flex-start" spacing={4}>
                <Grid item xs={12} md={6}>
                  <div className="user-data">
                    Available treasure : <div className="number">50</div>
                  </div>
                </Grid>
                {/* <Grid item xs={12} md={6}>
                  <div className="user-data time">
                    Treasure Remaining :{" "}
                    <div className="number">{mineableNum}</div>
                  </div>
                </Grid>
              </Grid>
            </div> */}
            {/* <div className="data-box luck">
              <div className="user-data">
                <Countdown date={1626107400000} renderer={countDownRender} />
                Reset Time
              </div>
            </div> */}
            <div className="data-box user">
              <div className="user-data">
                {nftType === 2 ? (
                  "You are the holder of other NFTs,"
                ) : nftType === 1 ? (
                  <div className="nft-num">
                    You have <div className="number">{nftNum}</div> KungFu{" "}
                    {nftNum <= 1 ? "Hero" : "Heroes"},
                  </div>
                ) : (
                  <div>
                    {" "}
                    You don't have any NFTs, You can mint on the{" "}
                    <Link to="/">HOME</Link> page.
                  </div>
                )}
              </div>
              {nftType !== 0 && isDataInit && (
                <div className="user-data time">
                  {/* <Countdown
                    date={Date.now() + seconds * 1000}
                    overtime
                    key="gameColdDown"
                    renderer={gameCountDownRender}
                  /> */}
                  {seconds > 0 ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      Time Remaining: <div className="number">{seconds} s</div>{" "}
                      for the treasure hunt.
                    </div>
                  ) : (
                    <div>You can continue treasure hunting now.</div>
                  )}
                </div>
              )}
            </div>
            <BorderLinearProgress value={percentValue} variant="determinate" />
            <div className="game-background">
              <MissChild
                missCoords={missCoords}
                rect={gameMainRefRect}
              ></MissChild>
              <WinChild winCoords={winCoords} rect={gameMainRefRect}></WinChild>
              <img
                src={Map}
                width="100%"
                onClick={onClickGameBox}
                alt=""
                id="game-map"
                onLoad={(element) => {
                  const rect = element.currentTarget.getBoundingClientRect();
                  setGameMainRefRect(rect);
                }}
              />
            </div>
            <Grid item xs={12} md={12} className="grant-reset-box">
              <div className="game-ranking">
                <div>Weekly Rankings</div>
              </div>
              <div className="game-ranking">
                <div>ADDRESS</div>
                <div>Point</div>
              </div>
              {rankingRes.map((item) => {
                return (
                  <div className="game-ranking">
                    <div>{item.address}</div>
                    <div>{item.gamePoint}</div>
                  </div>
                );
              })}
            </Grid>
            {/* <div className="mint-box">
              <Grid container justify="space-between" spacing={4}>
                <Grid item xs={12} md={6}>
                  <div className="left">
                    <div className="address">{`${userInfo.address.substring(
                      0,
                      6
                    )}...${userInfo.address.substring(
                      userInfo.address.length - 6,
                      userInfo.address.length
                    )}`}</div>
                    <div className="mint-desc">
                      Daily score: {}
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} md={6} className="button-box">
                  <Button
                    color="primary"
                    size="large"
                    className="mint-button"
                    disabled={
                      giftTimes <= 0 || loading.effects.game.winnerGetReward
                    }
                    onClick={() => {
                      winnerGetReward();
                    }}
                  >
                    Get Reward
                  </Button>
                </Grid>
              </Grid>
            </div> */}
            {canRewardTimes > 0 && (
              <div className="mint-box reward">
                <Grid container justify="space-between" spacing={4}>
                  <Grid item xs={12} md={6}>
                    <div className="left">
                      {/* <div className="address">{`${userInfo.address.substring(
                        0,
                        6
                      )}...${userInfo.address.substring(
                        userInfo.address.length - 6,
                        userInfo.address.length
                      )}`}</div> */}
                      <div className="mint-desc">
                        You can claim {canRewardTimes} KFH for free, only need
                        to pay gas fee once.(Based on our game records)
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={6} className="button-box">
                    <Button
                      color="primary"
                      size="large"
                      className="mint-button"
                      disabled={
                        canRewardTimes <= 0 ||
                        loading.effects.game.winnerGetReward
                      }
                      onClick={() => {
                        winnerGetReward();
                      }}
                    >
                      Get Reward
                    </Button>
                  </Grid>
                </Grid>
              </div>
            )}
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
